import { format } from "date-fns";
import { sv } from "date-fns/locale";

/**
 * Returns a calm Swedish relative label for a date within the next 7 days.
 * - Same day → "Idag"
 * - Tomorrow → "Imorgon"
 * - 2–6 days → Swedish weekday name, capitalized (e.g. "Fredag")
 * - Beyond 7 days or null → null
 */
export function humanizeLandingDate(dateStr: string | null): string | null {
  if (!dateStr) return null;

  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = target.getTime() - now.getTime();

  if (diffMs < 0) return null;

  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  if (diffDays > 7) return null;

  // Same calendar day
  if (
    target.getFullYear() === now.getFullYear() &&
    target.getMonth() === now.getMonth() &&
    target.getDate() === now.getDate()
  ) {
    return "Idag";
  }

  // Tomorrow
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (
    target.getFullYear() === tomorrow.getFullYear() &&
    target.getMonth() === tomorrow.getMonth() &&
    target.getDate() === tomorrow.getDate()
  ) {
    return "Imorgon";
  }

  // 2–6 days: Swedish weekday name, capitalize first letter
  const weekday = format(target, "EEEE", { locale: sv });
  return weekday.charAt(0).toUpperCase() + weekday.slice(1);
}
